/* eslint-disable complexity */
import { BookWidgetShopMilesField } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const prepareFlexAirportsField = (
  queryParams: QueryParams | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  hasDeepLinkingParams: boolean
): BookWidgetShopMilesField => {
  if (bookWidgetFieldsMasterConfig.flexAirportsField?.hide) {
    return {
      checked: false,
      disable: false,
      hide: true
    };
  }

  let checked = false;
  if (
    !bookWidgetFieldsMasterConfig?.flexAirportsField?.disable &&
    stringToBoolean(queryParams?.flexAirport)
  ) {
    checked = true;
  } else if (
    !hasDeepLinkingParams &&
    !bookWidgetFieldsMasterConfig?.flexAirportsField?.disable &&
    retrieveSearchData?.nearbyAirports
  ) {
    checked = true;
  }

  return {
    checked,
    disable: bookWidgetFieldsMasterConfig.flexAirportsField?.disable || false,
    hide: bookWidgetFieldsMasterConfig.flexAirportsField?.hide || false
  };
};
